const API_URL = 'https://accwebapi.avsinsotech.com/api';
//const API_URL = 'https://localhost:7284/api';

export default API_URL;